import moment from 'moment';
import { Link as RouterLink } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  Divider,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import helper from 'src/utils/helpers';


const LatestOrders = (props) => (
  <Card {...props}>
    <CardHeader title={<div className="w-100 d-flex"><Typography variant="h5" color="primary" className="flex-grow-1">Recent Loans</Typography><IconButton
    component={RouterLink}
    to={'/app/applications'}
    ><AddToPhotosIcon className="text-primary"/></IconButton></div>} />
    <Divider />
    <PerfectScrollbar>
      <Box >
      {props.loans.length === 0 ? <div className="center-element m-2" style={{with: '100%', margin: 'auto'}}>No Loan History</div> : 
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell width="80">
               Loan ID
              </TableCell>
              <TableCell align="left" width="150">
                Loan Amount
              </TableCell>
              <TableCell width="100"> 
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            
            { props.loans.length !== 0 && props.loans.map((order) => (
              <TableRow
                hover
                key={order.loanId}
              >
                <TableCell>
                  {order.loanId}
                  {console.log(order)}
                </TableCell>
                <TableCell>
                {helper.toCurrency(order.loanAmount)}
                </TableCell>
                <TableCell>
                  <Chip
                    color="primary"
                    label={order.isPaid ? 'Paid' : order.status}
                    size="small"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>}
      </Box>
    </PerfectScrollbar>
    { props.loans.length !== 0 &&  <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        p: 2
      }}
    >
      <Button
    component={RouterLink}
        color="primary"
        endIcon={<ArrowRightIcon />}
        size="small"
        variant="text"
    to={'/app/applications'}
      >
        View all
      </Button>
    </Box> }
  </Card>
);

export default LatestOrders;
